import React from 'react';
import './ClienteTable.css';

const ClienteTable = ({ clientes }) => {
  if (!clientes || clientes.length === 0) {
    return (
      <div className="table-container">
        <div className="no-data">
          <div className="no-data-icon">📊</div>
          <p>Nenhum cliente encontrado</p>
        </div>
      </div>
    );
  }

  // Define a ordem específica das colunas
  const columnOrder = ['codconexao', 'nome_razaosocial', 'local', 'status'];
  
  // Filtra apenas as colunas que existem no objeto
  const columns = columnOrder.filter(col => clientes[0].hasOwnProperty(col));

  // Função para formatar valores especiais
  const formatValue = (column, value) => {
    if (column === 'status') {
      switch (value) {
        case 'Ativo': return '✅ Ativo';
        case 'Cortesia': return '🎁 Cortesia';
        case 'Cancelado': return '❌ Cancelado';
        case 'Inadimplencia': return '⚠️ Inadimplência';
        case 'A Instalar': return '🔧 A Instalar';
        default: return value || '-';
      }
    }
    if (column === 'cancelado') {
      return value === 'S' ? 'S' : 'N';
    }
    if (column === 'suspenso') {
      return value === 'S' ? 'S' : 'N';
    }
    if (value === null || value === undefined) {
      return '-';
    }
    return String(value);
  };

  // Função para renderizar o valor com badge quando necessário
  const renderCellContent = (column, value) => {
    const formattedValue = formatValue(column, value);
    
    if (column === 'status') {
      let badgeClass = '';
      switch (value) {
        case 'Ativo': badgeClass = 'status-ativo'; break;
        case 'Cortesia': badgeClass = 'status-cortesia'; break;
        case 'Cancelado': badgeClass = 'status-cancelado'; break;
        case 'Inadimplencia': badgeClass = 'status-inadimplente'; break;
        case 'A Instalar': badgeClass = 'status-a-instalar'; break;
        default: return formattedValue;
      }
      return <span className={badgeClass}>{formattedValue}</span>;
    }
    
    if (column === 'local') {
      return <span className="local-cell">{formattedValue}</span>;
    }
    
    return formattedValue;
  };

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column}>
                  {column === 'codconexao' ? 'Código' :
                   column === 'nome_razaosocial' ? 'Nome' :
                   column === 'tipo_conexao' ? 'Tipo Conexão' :
                   column === 'cancelado' ? 'Cancelado' :
                   column === 'suspenso' ? 'Suspenso' :
                   column === 'status' ? 'Status' :
                   column === 'local' ? 'Localidade' :
                   column.charAt(0).toUpperCase() + column.slice(1)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {clientes.map((cliente, index) => (
              <tr key={index}>
                {columns.map((column) => (
                  <td key={column}>
                    {renderCellContent(column, cliente[column])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClienteTable;

